import { render } from "./BidChecklistsOverview.vue?vue&type=template&id=2f534f94&scoped=true"
import script from "./BidChecklistsOverview.vue?vue&type=script&lang=js"
export * from "./BidChecklistsOverview.vue?vue&type=script&lang=js"

import "./BidChecklistsOverview.vue?vue&type=style&index=0&id=2f534f94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f534f94"]])

export default __exports__